// Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
export enum LayerType {
  //SkipDouble
  SkipDouble = 0,

  //Population
  Population = 1,

  // CoverageRender
  Coverage = 2,

  // generic / unknown
  Generic = 3,

  // Paths
  Path = 4,

  // Driven path
  DrivenPath = 5,

  // Estimated coverage
  EstimatedCoverage = 6,

  // Obstacles,
  Obstacle = 7,

  // Recorded Planned Path
  PlannedPath = 8,

  //Yield
  Yield = 15,

  //LiveData
  LiveData = 101
}
